import React from 'react';
import { IconButton } from "@mui/material";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { removeItem, removeUnavailable, updateQuantity } from "../../../Store/reducers/cartReducer";
import ProductPrice from '../../ProductPrice/ProductPrice';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, useIntl } from 'react-intl';
import "./BasketStep.scss"

const BasketStep = () => {
    const products = useSelector((state) => state.cart.products);
    const dispatch = useDispatch();
    const intl = useIntl();

    const changeQuantity = (item, delta) =>
        dispatch(updateQuantity({ id: item.id, quantity: item.quantity + delta }));

    return (
        <div className='basketStep'>
            <h2 className="basketStep__title"><FormattedMessage id="your_cart_products" /></h2>
            {products.some((item) => item.unavailable) && (
                <div className="basketStep__warning" role="alert">
                    <FormattedMessage id="cart_has_unavailable" />{" "}
                    <button type="button" onClick={() => dispatch(removeUnavailable())}>
                        <FormattedMessage id="cart_remove_unavailable" />
                    </button>
                </div>
            )}
            {products.length === 0 ? (
                <p className="basketStep__empty"><FormattedMessage id="cart_is_empty" /></p>
            ) : (
                products.map((item) => {
                    const atMax = item.stock != null && item.quantity >= item.stock;
                    return (
                        <div className={`item${item.unavailable ? " is-unavailable" : ""}`} key={item.id}>
                            <img
                                src={process.env.REACT_APP_UPLOAD_URL + item.img}
                                alt={item.title}
                                loading="lazy"
                            />
                            <div className="details">
                                <h3>{item.title}</h3>
                                <div className="price">
                                    <ProductPrice basePrice={item?.new_price} />
                                </div>
                                {item.unavailable ? (
                                    <span className="unavailable"><FormattedMessage id="out_of_stock_short" /></span>
                                ) : (
                                <div className="qty" aria-label={intl.formatMessage({ id: "quantity" })}>
                                    <button
                                        type="button"
                                        onClick={() => changeQuantity(item, -1)}
                                        disabled={item.quantity <= 1}
                                        aria-label="-"
                                    >−</button>
                                    <span>{item.quantity}</span>
                                    <button
                                        type="button"
                                        onClick={() => changeQuantity(item, 1)}
                                        disabled={atMax}
                                        aria-label="+"
                                    >+</button>
                                </div>
                                )}
                            </div>
                            <IconButton
                                className="delete"
                                onClick={() => dispatch(removeItem(item.id))}
                                aria-label={intl.formatMessage({ id: "remove_item" })}
                            >
                                <DeleteOutlinedIcon />
                            </IconButton>
                        </div>
                    );
                })
            )}
        </div>
    );
};

export default BasketStep;
